import React from 'react'
import { Space } from 'antd'
import { UserOutlined, HomeOutlined, FrownOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { ConformityTableType } from './types'

interface IProps {
  conformity: ConformityTableType
}

const LinkButtons = (props: IProps) => {
  const { t } = useTranslation()
  const { conformity } = props

  const pappersUrl = (search: string) =>
    encodeURI(`https://www.pappers.fr/recherche?q=${search}`)

  const societycomUrl = (search: string) =>
    encodeURI(`https://www.societe.com/cgi-bin/search?champs=${search}`)

  return (
    <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
      <span>{t('conformities:modal.link-pappers')}</span>
      <Space size="middle" style={{ display: 'flex' }}>
        <a
          href={pappersUrl(conformity.societyName)}
          target="_blank"
          rel="noreferrer"
        >
          <HomeOutlined />
        </a>
        <a
          href={pappersUrl(`${conformity.firstname} ${conformity.lastname}`)}
          target="_blank"
          rel="noreferrer"
        >
          <UserOutlined />
        </a>
      </Space>
      <span>{t('conformities:modal.link-society-com')}</span>
      <Space size="middle" style={{ display: 'flex' }}>
        <a
          href={societycomUrl(conformity.societyName)}
          target="_blank"
          rel="noreferrer"
        >
          <HomeOutlined />
        </a>
        <a
          href={societycomUrl(`${conformity.firstname} ${conformity.lastname}`)}
          target="_blank"
          rel="noreferrer"
        >
          <UserOutlined />
        </a>
      </Space>
      <span>{t('conformities:modal.link-infogreffe')}</span>
      <div>
        <a href="https://www.infogreffe.fr/" target="_blank" rel="noreferrer">
          <FrownOutlined />
        </a>
      </div>
    </Space>
  )
}

export default LinkButtons
